import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "page-not-found min-h-screen flex items-center justify-center bg-slate-900"
};
const _hoisted_2 = {
  class: "text-center"
};
export default /*@__PURE__*/Object.assign({
  name: 'PageNotFound'
}, {
  __name: 'PageNotFound',
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[1] || (_cache[1] = _createElementVNode("h1", {
        class: "text-9xl font-bold text-slate-700"
      }, "404", -1)), _cache[2] || (_cache[2] = _createElementVNode("p", {
        class: "text-xl text-slate-400 mt-4"
      }, "抱歉，您访问的页面不存在", -1)), _createVNode(_component_router_link, {
        to: "/dashboard",
        class: "btn-primary mt-6"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode(" 返回首页 ", -1)]))]),
        _: 1
      })])]);
    };
  }
});